import styled from 'styled-components';
export var Blockquote = styled.blockquote.withConfig({
  displayName: "Blockquote",
  componentId: "sc-mjh7dl-0"
})(["position:relative;padding:0 36px 0 24px;margin:0 0 0 12px;&:before{position:absolute;top:0;bottom:0;left:0;border-left:4px solid ", ";border-radius:4px;content:'';}"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderColor;
});